import { SeoMetaTypeEnum } from '@is24at/react-enums';
import seoRules from 'core/seoRules';

const header = ({ searchQuery }: any) =>
  seoRules.lookupAndFormatFor(SeoMetaTypeEnum.HEADER, searchQuery);

export default header;
